export type CustomComponent = {
  type: "tool-display";
  data: ToolDisplayData;
};

export interface KnowledgeItem {
  title: string;
  content: string;
  relevance_score?: number;
  url?: string;
}

export interface ToolDisplayData {
  toolName: string;
  args: Record<string, any>;
}

export const TOOL_TYPES = {
  SUGGEST_BRIEF_EDIT: "suggest_brief_edit",
  SUGGEST_INSTRUCTION_ADD: "suggest_instruction_add",
  SUGGEST_PREREQUISITE_ADD: "suggest_prerequisite_add",
} as const;
